import React, { useCallback, useContext, useEffect, useState } from "react";
import {
  Button,
  DatePicker,
  Form,
  Input,
  Modal,
  Space,
  Table,
  Tooltip,
} from "antd";
import {
  PlusOutlined,
  AuditOutlined,
  CalendarOutlined,
} from "@ant-design/icons";
import axios from "axios";
import moment from "moment";
import { NotificationInfo, UserInfo } from "../../../context";
import MerchantLayout from "../../layout/MerchantLayout";
// import AddProduction from "./AddProduction";
import ProductionDetails from "./ProductionDetails";
import NewAddProduction from "./NewAddProduction";
// import AddRawProcess from "./AddRawProcess";
// import RawProcessDetails from "./RawProcessDetails";

const Production = () => {
  const [rawProcessList, setRawProcessList] = useState({
    data: [],
    ready: false,
  });
  const [openDrawer, setOpenDrawer] = useState(false);
  const tableLayout = "";
  const scroll = {};
  const { userData } = useContext(UserInfo);
  const [selectedTab, setSelectedTab] = useState("list");
  const [selectedData, setSelectedData] = useState(null);
  const [openFilterByDate, setOpenFilterByDate] = useState(false);
  const { rerunNotif } = useContext(NotificationInfo);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");

  const columns = [
    {
      title: "Process Date",
      dataIndex: "created_at",
      render: (date) => (
        <p>{moment(new Date(date), "YYYY-MM-DD").format("MMMM DD, YYYY")}</p>
      ),
    },
    {
      title: "Track ID",
      dataIndex: "track_id",
      sorter: (a, b) => a.track_id - b.track_id,
      render: (text, record) => (
        <p
          style={{
            color: "blue",
          }}
        >
          {text}
        </p>
      ),
    },
    {
      title: "Raw Product",
      dataIndex: ["processsaverawproduct2", "product"],
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      render: (text, record) => (
        <p
          style={{
            fontSize: 12,
          }}
        >
          {text}
        </p>
      ),
    },
    {
      title: "Expected Quantity",
      dataIndex: "expected_quantity",
      align: "right",
      render: (text, record) => <p>{text}</p>,
    },
    {
      title: "",
      dataIndex: "",
      align: "center",
      render: (text) => (
        <p>
          <Tooltip title="Details">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setOpenDrawer(true);
              }}
              icon={<AuditOutlined />}
            />
          </Tooltip>
        </p>
      ),
    },
  ];

  const tableProps = {
    bordered: false,
    loading,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const getRawProcessList = useCallback(() => {
    var params = { user_id: userData.data.id };
    axios
      .get("user/merchant/raw-process-save-list", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setRawProcessList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  useEffect(() => {
    getRawProcessList();
  }, [getRawProcessList]);

  const searchable = rawProcessList.data.filter((data) => {
    return data.track_id.toLowerCase().indexOf(search.toLowerCase()) >= 0;
  });

  const handleFilter = (values) => {
    var params = {
      date_from: moment(new Date(values.date_from), "YYYY-MM-DD").format(
        "YYYY-MM-DD"
      ),
      date_to: moment(new Date(values.date_to), "YYYY-MM-DD").format(
        "YYYY-MM-DD"
      ),
      user_id: userData.data.id,
    };
    setLoading(true);
    axios
      .get("user/merchant/filter/raw-process-save-list", { params })
      .then((response) => {
        const data = response.data;
        rerunNotif("success", "Filter successful.");
        setTimeout(() => {
          setOpenFilterByDate(false);
          setLoading(false);
          setRawProcessList({ data, ready: true });
        }, 1000);
      })
      .catch((error) => {
        console.log("Error: ", error);
        // setLoadings(false);
      });
  };

  return (
    <MerchantLayout>
      <div>
        {selectedTab === "list" && (
          <>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginBottom: 5,
              }}
            >
              <div style={{ flexGrow: 1 }}>
                <Input
                  placeholder="Search track id"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  style={{
                    border: "2px solid #e5e5e5",
                    width: window.innerWidth < 576 ? "100%" : 300,
                  }}
                  size="large"
                />
              </div>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => setSelectedTab("form")}
              >
                Create Product
              </Button>

              <Tooltip title="Filter by date">
                <Button
                  icon={<CalendarOutlined />}
                  style={{ marginLeft: 5 }}
                  onClick={() => setOpenFilterByDate(true)}
                >
                  Filter
                </Button>
              </Tooltip>
            </div>

            <div style={{ overflowX: "auto" }}>
              <Table
                {...tableProps}
                pagination={{
                  position: ["bottomCenter"],
                }}
                columns={tableColumns}
                dataSource={searchable.length > 0 ? searchable : []}
                scroll={scroll}
                rowKey={(record) => record.track_id}
              />
            </div>
          </>
        )}
        {selectedTab === "form" && (
          <NewAddProduction
            close={() => setSelectedTab("list")}
            getRawProcessList={() => getRawProcessList()}
          />
        )}

        {openDrawer && (
          <ProductionDetails
            open={openDrawer}
            close={() => setOpenDrawer(false)}
            selectedData={selectedData}
          />
        )}
      </div>

      <Modal
        title=""
        open={openFilterByDate}
        onCancel={() => setOpenFilterByDate(false)}
        footer={null}
        width={350}
      >
        <Form
          layout="vertical"
          name="basic"
          initialValues={{ remember: false }}
          onFinish={handleFilter}
          autoComplete="off"
        >
          <Space
            direction="vertical"
            style={{ width: "100%", margin: 0, marginTop: 20 }}
          >
            <Form.Item
              name="date_from"
              label="Date From"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <DatePicker
                format={"MM/DD/YYYY"}
                size="large"
                style={{ width: "100%" }}
              />
            </Form.Item>

            <Form.Item
              name="date_to"
              label="Date To"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <DatePicker
                format={"MM/DD/YYYY"}
                size="large"
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Space>

          <Form.Item style={{ marginTop: "20px" }}>
            <Button
              type="primary"
              loading={loading}
              htmlType="submit"
              style={{ width: "100%", borderRadius: "20px" }}
            >
              {loading ? "Loading" : "Filter"}
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </MerchantLayout>
  );
};

export default Production;
